/**
 * Shared brand tokens for marketing/public pages (aligned with App.css).
 */
const BRAND = {
  primary: '#2D5074',
  primaryDark: '#1D4064',
  black: '#010101',
  accent: '#a5e2ff',
  /** Served from frontend/public (CRA copies to build root). Update: copy from backend/assets/logo.png when refreshed. */
  logoSrc: `${process.env.PUBLIC_URL || ''}/logo.png`,
};

export default BRAND;
